import { LostStrand } from "@/pages/caster/models/caster.models";
import { EditAndDeleteButtons } from "@/pages/eaf/data-entry/components/tables/components/EditAndDeleteButtons";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { ManualAutoButton } from "../../../buttons/ManualAutoButton";

type Props = {
	onDeleteButtonClick: (lostStrandId: number) => void;
	onEditButtonClick: (lostStrandId: number) => void;
};

export const useLostStrandTableData = ({
	onDeleteButtonClick,
	onEditButtonClick,
}: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Lost Strands",
			children: [
				{
					field: "isManual",
					headerName: " ",
					flex: 1,
					minWidth: 50,
					maxWidth: 50,
					cellRenderer: (params: ICellRendererParams) => {
						return <ManualAutoButton isManual={params.data.IsManual} />;
					},
				},
				{
					field: "StrandId",
					headerName: "Strand",
					flex: 1,
					minWidth: 70,
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 59,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return dxtToLocalServerTime(params.data.Timestamp, "HH:mm");
						}
					},
				},
				{
					field: "LostStrandTypeName",
					headerName: "Comment",
					flex: 3,
					minWidth: 50,
					wrapText: true,
					autoHeight: true,
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 50,

					maxWidth: 50,
					cellStyle: {
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					},
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: onDeleteButtonClick,
						edit: onEditButtonClick,
						id: (params.data as LostStrand).LostStrandId,
					}),
				},
			],
		},
	];

	return { columns };
};
